import { FrontUrls } from 'Constants/FrontUrls'
import React, { lazy } from 'react'
import { LazyRoute, filtersSlice, PAGE_SLUG } from 'Modules'
import { Switch } from 'react-router-dom'
import { useUnmount } from 'Src/hooks/useUnmount'
import { useDispatch } from 'react-redux'

const PartnerRequestListLazy = lazy(
	() => import('Pages/partnerRequests/components/PartnerRequestList')
)
const PartnerRequestEditFormLazy = lazy(
	() => import('Pages/partnerRequests/components/PartnerRequestEditForm')
)
const PartnerRequestNewFormLazy = lazy(
	() => import('Pages/partnerRequests/components/PartnerRequestNewForm')
)

export const PartnerRequestRoutes = () => {
	const dispatch = useDispatch()
	useUnmount(() => {
		dispatch(filtersSlice.actions.clearFilters(PAGE_SLUG.PARTNER_REQUEST))
	})

	return (
		<Switch>
			<LazyRoute
				exact
				path={FrontUrls.partner_request.index}
				lazyComponent={PartnerRequestListLazy}
				key={FrontUrls.partner_request.index}
			/>
			<LazyRoute
				exact
				path={FrontUrls.partner_request.edit}
				lazyComponent={PartnerRequestEditFormLazy}
				key={FrontUrls.partner_request.edit}
			/>
			<LazyRoute
				exact
				path={FrontUrls.partner_request.create}
				lazyComponent={PartnerRequestNewFormLazy}
				key={FrontUrls.partner_request.create}
			/>
		</Switch>
	)
}
